<template>
    <v-container class="fill-height">
        <v-layout flex align-center justify-center>
            <v-card class="elevation-12" width="50%" min-width="300">
                <v-toolbar color="primary" dark>
                    <v-toolbar-title>映智科技後台管理</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-form ref="form" v-model="valid" lazy-validation>
                        <v-text-field
                            prepend-icon="mdi-account"
                            v-model="email"
                            label="E-mail"
                            :rules="rules.email"
                            autocomplete="email"
                        ></v-text-field>
                        <v-text-field
                            prepend-icon="mdi-lock"
                            v-model="password"
                            label="Password"
                            type="password"
                            :rules="rules.password"
                            autocomplete="current-password"
                            @keyup.enter="submit"
                        ></v-text-field>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        class="mr-4"
                        :disabled="!valid"
                        color="primary"
                        text
                        @click="submit"
                        :loading="loading"
                        >登入</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-layout>
    </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    data: () => ({
        valid: false,
        email: '',
        password: '',
        rules: {
            email: [
                (v) => !!v || 'E-mail is required',
                (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
            ],
            password: [
                (v) => !!v || 'Password is required',
            ],
        },
        loading: false,
    }),
    computed: {
        ...mapGetters('auth', ['currentUser']),
    },
    methods: {
        ...mapActions('auth', ['login']),
        async submit() {
            if (this.$refs.form.validate()) {
                this.loading = true;
                try {
                    const data = { account: this.email, password: this.password };
                    await this.login(data);
                } catch (e) {
                    this.$showApiError(e);
                } finally {
                    this.loading = false;
                }
            }
        },
        routeToFirstPage() {
            this.$router.replace({ name: 'News' });
        },
    },
    watch: {
        currentUser(after, before) {
            if (before === null && after !== null) {
                this.routeToFirstPage();
            }
        },
    },
    mounted() {
        if (process.env.NODE_ENV !== 'production') {
            this.email = 'admin@gmail.com';
            this.password = '12345678';
        }
    },
};
</script>

<style scoped>
</style>
